import React  from 'react'
import { Modal } from 'antd'
import {ViewMajorMonotone} from '@shopify/polaris-icons'
import { Button } from '@shopify/polaris'
import ObjectInspector from "react-object-inspector"

const ViewResponseStatus = (props) => {
    const {response} = props
    const {data = {}} = response
    const [modal, contextHolder] = Modal.useModal()

    const config = {
        title: 'Response Status',
        width: '700px',
        content: (
            <ObjectInspector depth={0} path="root.value" data={data} />
        ),
    };

    return (
        <React.Fragment>
            <Button onClick={() => {
                modal.info(config);
            }} id="ViewPayload" icon={ViewMajorMonotone}/>

            {contextHolder}
        </React.Fragment>
    )
}
export default ViewResponseStatus